export { StyledColumn } from './StyledColumn'